import React from 'react';
import { useSelector } from 'react-redux';
import { LockOutlined } from '@ant-design/icons';
import { isAdminRoleSelector } from '@src/store/common/selectors';
import { StyledTag } from './styled';

const AdminOnly = ({ style = {} }) => {
  const isAdminUser = useSelector(isAdminRoleSelector);

  return !isAdminUser ? (
    <StyledTag style={style} icon={<LockOutlined />}>
      Read Only
    </StyledTag>
  ) : null;
};

export default AdminOnly;
